/**********************
	API functions
**********************/

/* eslint-disable */
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

// Fetch TravelAdvance table data (ongoing, submitted, completed)
export const fetchTableData = async (category) => {
	try {
		if (category) {
			let url = process.env.REACT_APP_SERVER_URL + "/functions/";
			// update url based on category
			switch (category) {
				case "ongoing":
					url += "getOngoingTA";
					break;
				case "submitted":
					url += "getSubmittedTA";
					break;
				case "completed":
					url += "getCompletedTA";
					break;
				case "savings":
					url += "getTravelSavings";
					break;
				default:
					return [];
			}

			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				headers: requestHeaders,
				body: JSON.stringify({
					// queryType: filter,
				}),
			});
			const data = await response.json();
			console.log(category, data.result);
			return data ? data.result : [];
		} else return null;
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single TravelAdvance object
export const fetchSingleObject = async (objectId) => {
	try {
		if (objectId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/viewTA";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ id: objectId }),
				headers: requestHeaders,
			});
			const data = await response.json();
			console.log(objectId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Object ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};
